import { _ as _defineProperty } from '../_rollupPluginBabelHelpers-ec67cb00.js';
import s__default from '@ember/service';

class LiquidFireChild {
  constructor(uniqueChildId, componentClass) {
    this.uniqueChildId = uniqueChildId;
    this.componentClass = componentClass;
  }
}
class LiquidFireChildrenService extends s__default {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "children", []);
    _defineProperty(this, "_waitingFor", []);
  }
  register(uniqueChildId, componentClass) {
    const child = new LiquidFireChild(uniqueChildId, componentClass);
    this.children.push(child);
    return child;
  }
  unregister(child) {
    const index = this.children.indexOf(child);
    if (index === -1) {
      return;
    }
    this.children.splice(index, 1);
  }
  closest(element) {
    if (!element) {
      return null;
    }
    const closestElement = element.closest('[data-liquid-child]');
    if (!closestElement) {
      return null;
    }
    if (closestElement.getAttribute('data-liquid-child') === element.getAttribute('data-liquid-child')) {
      return null;
    }
    const child = this.children.find(x => x.uniqueChildId === closestElement.getAttribute('data-liquid-child'));
    if (!child) {
      return null;
    }
    return child.componentClass;
  }
}

export { LiquidFireChildrenService as default };
//# sourceMappingURL=liquid-fire-children.js.map
